import { render, staticRenderFns } from "./HealthCardModal.vue?vue&type=template&id=07ffaec1&"
import script from "./HealthCardModal.vue?vue&type=script&lang=js&"
export * from "./HealthCardModal.vue?vue&type=script&lang=js&"
import style0 from "./HealthCardModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports